"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasMentions = exports.parseMessageWithMentions = void 0;
/**
 * Parses message body and returns segments with mentions identified.
 * Uses mentionedUsers array to find user names in the message text.
 *
 * @param body - The message body text
 * @param mentionedUsers - Array of user IDs who are mentioned
 * @param getUserName - Function to get user name from user ID
 * @returns Array of text segments with mention flags
 */
const parseMessageWithMentions = (body, mentionedUsers, getUserName) => {
    if (!body || !mentionedUsers || mentionedUsers.length === 0) {
        return [{ text: body || "", isMention: false }];
    }
    // Get names for all mentioned users
    const mentionNames = mentionedUsers
        .map(userId => getUserName(userId))
        .filter((name) => !!name);
    if (mentionNames.length === 0) {
        return [{ text: body, isMention: false }];
    }
    // Create a regex pattern to match any of the mentioned names (with optional @ prefix)
    // Sort by length (longest first) to match longer names before shorter ones
    const sortedNames = [...mentionNames].sort((a, b) => b.length - a.length);
    const escapedNames = sortedNames.map(name => name.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"));
    // Match @name or just name (@ is optional to handle both formats)
    const pattern = new RegExp(`(@?(?:${escapedNames.join("|")}))`, "gi");
    const segments = [];
    let lastIndex = 0;
    let match;
    while ((match = pattern.exec(body)) !== null) {
        // Add text before the match
        if (match.index > lastIndex) {
            segments.push({
                text: body.slice(lastIndex, match.index),
                isMention: false,
            });
        }
        // Add the matched mention
        segments.push({
            text: match[0],
            isMention: true,
        });
        lastIndex = pattern.lastIndex;
    }
    // Add remaining text after last match
    if (lastIndex < body.length) {
        segments.push({
            text: body.slice(lastIndex),
            isMention: false,
        });
    }
    return segments.length > 0 ? segments : [{ text: body, isMention: false }];
};
exports.parseMessageWithMentions = parseMessageWithMentions;
/**
 * Checks if a message has any mentions that need highlighting
 */
const hasMentions = (mentionedUsers) => {
    return !!mentionedUsers && mentionedUsers.length > 0;
};
exports.hasMentions = hasMentions;
